import {createSlice} from "@reduxjs/toolkit";

export const AccessSlice = createSlice({
    name: 'access',
    initialState: {
        dined: null,
    },
    reducers: {
        setDined: (state, action) => {
            state.dined = action.payload;
        },
        delDined: (state) => {
            state.dined = null;
        }
    }
})

export const { setDined, delDined} = AccessSlice.actions;

export default AccessSlice.reducer;